'use client';

import MetricLineChart from '../MetricLineChart';
import MetricGauge from '../MetricGauge';

// Sample data: Deployment frequency over time
const trendData = [
  { name: 'Week 1', deploymentsPerDay: 2.1 },
  { name: 'Week 2', deploymentsPerDay: 2.8 },
  { name: 'Week 3', deploymentsPerDay: 3.2 },
  { name: 'Week 4', deploymentsPerDay: 3.8 },
  { name: 'Week 5', deploymentsPerDay: 4.2 },
  { name: 'Week 6', deploymentsPerDay: 4.5 },
  { name: 'Week 7', deploymentsPerDay: 4.8 },
  { name: 'Week 8', deploymentsPerDay: 5.2 },
];

export function DeploymentFrequencyTrend() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">📈 Deployment Frequency Trend</h3>
      <MetricLineChart
        data={trendData}
        lines={[
          { dataKey: 'deploymentsPerDay', name: 'Deployments per Day', color: '#E89841' },
        ]}
        xAxisLabel="Time Period"
        yAxisLabel="Deployments per Day"
        targetLine={4}
        height={350}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Sample data showing improvement from 2.1 to 5.2 deployments per day over 8 weeks.
        The green dashed line represents the Elite threshold (4+ per day).
      </p>
    </div>
  );
}

export function DeploymentFrequencyGauge() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">🎯 Current Performance</h3>
      <MetricGauge
        value={4.2}
        max={10}
        label="Deployments per Day"
        ranges={[
          { min: 0, max: 10, color: '#EB5757', label: 'Low' },
          { min: 10, max: 40, color: '#F2C94C', label: 'Medium' },
          { min: 40, max: 70, color: '#4A90E2', label: 'High' },
          { min: 70, max: 100, color: '#6FCF97', label: 'Elite' },
        ]}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Current deployment frequency at 4.2 per day places the team in the Elite category (10+ per week).
      </p>
    </div>
  );
}
